module.exports = __webpack_public_path__ + "app/img/steam.d95a5234d1.svg";